// This file is auto-generated by @hey-api/openapi-ts

import { z } from 'zod';

/**
 * Site ID
 */
export const zSiteId = z.number().int().min(-2147483648, { message: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' });

/**
 * Site section ID
 */
export const zSiteSectionId = z.number().int().min(-2147483648, { message: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' });

export const zSectionParentRef = z.object({
    id: zSiteSectionId,
    namePath: z.string()
});

/**
 * Site section category ID
 */
export const zSiteSectionCategoryId = z.number().int().min(-2147483648, { message: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' });

export const zSectionCategory = z.object({
    id: zSiteSectionCategoryId,
    name: z.string()
});

/**
 * Programming category for appliances.
 */
export const zApplianceCategory = z.enum([
    'AC_UNIT_NON_INFRARED',
    'AIR_HANDLING_UNIT',
    'BOILER',
    'BOOKABLE_SPACE',
    'CHARGING_STATION',
    'CHILLER',
    'CHILLER_FOOD_GRADE',
    'GENERATOR_SET',
    'HEATER',
    'HEATER_STORAGE',
    'HEATER_UNIT',
    'HEATING_FLOOR',
    'HEAT_PUMP',
    'HEAT_PUMP_DHW',
    'HEAT_PUMP_WITH_TEMPERATURE',
    'POOL_HEATER',
    'PUMP_MOTOR',
    'RADIANT_CEILING_PANEL',
    'WATER_HEATER'
]);

/**
 * Number of programmable appliances attached to the section, grouped by appliance programming category. Missing categories have an implicit count of zero.
 */
export const zApplianceCountByProgrammingCategory = z.record(z.number().int().gte(0).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' }));

export const zHospitalitySectionNodeResponse: z.AnyZodObject = z.object({
    id: zSiteSectionId,
    name: z.string(),
    area: z.number().int().min(-2147483648, { message: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' }).nullable(),
    parent: zSectionParentRef.nullable(),
    category: zSectionCategory.nullish(),
    applianceCountByProgrammingCategory: zApplianceCountByProgrammingCategory,
    children: z.array(z.lazy(() => zHospitalitySectionNodeResponse))
});

export const zHospitalitySectionForestResponse = z.object({
    sections: z.array(zHospitalitySectionNodeResponse)
});

export const zJsonHttpReadError = z.object({
    message: z.string().optional()
});

export const zJsonUnexpectedError = z.object({
    errorType: z.string().optional(),
    message: z.string().nullish()
});

export const zJsonDomainError = z.object({
    errorType: z.string().optional(),
    errorCode: z.string().optional(),
    message: z.string().nullish()
});

export const zJsonTechnicalError = z.object({
    errorType: z.string().optional(),
    errorCode: z.string().optional(),
    message: z.string().nullish()
});

export const zJsonFieldError = z.object({
    errorCode: z.string().nullish(),
    message: z.string(),
    propertyPath: z.string().nullish()
});

export const zJsonFormValidationError = z.object({
    fieldErrors: z.array(zJsonFieldError).optional()
});

/**
 * Common API error wrapper.
 */
export const zJsonErrorWrapper = z.object({
    errorCategory: z.enum([
        'DOMAIN_ERROR',
        'TECHNICAL_ERROR',
        'FORM_VALIDATION_ERROR',
        'UNEXPECTED_ERROR',
        'HTTP_READ_ERROR'
    ]),
    errorDetails: z.union([
        zJsonHttpReadError,
        zJsonUnexpectedError,
        zJsonDomainError,
        zJsonTechnicalError,
        zJsonFormValidationError
    ]).nullish()
});

export const zUpdateSectionsCategoriesRequest = z.object({
    sectionsWithCategories: z.array(z.object({
        sectionId: zSiteSectionId,
        sectionCategoryId: zSiteSectionCategoryId.nullish()
    }))
});

/**
 * Site section name. Must be non-blank and at most 150 characters.
 */
export const zSiteSectionName = z.string().max(150);

/**
 * Section area in square meters.
 */
export const zSiteSectionArea = z.number().int().gte(0).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' });

export const zHospitalityCreateSiteSectionRequest = z.object({
    name: zSiteSectionName,
    area: zSiteSectionArea.nullish(),
    parentId: zSiteSectionId.nullish()
});

/**
 * Reference to a freshly created site section.
 */
export const zSiteSectionCreatedEntityReference = z.object({
    id: zSiteSectionId,
    type: z.literal('SiteSection')
});

/**
 * Fields to patch on a site section. Omitted properties are left unchanged.
 */
export const zPatchSiteSectionRequest = z.object({
    name: zSiteSectionName.optional(),
    area: zSiteSectionArea.nullish()
});

export const zSectionDeletableResponse = z.object({
    isDeletable: z.boolean()
});

/**
 * Target location for the section move.
 */
export const zMoveSiteSectionRequest = z.object({
    parentId: zSiteSectionId.nullish()
});

/**
 * Payload to create a section category
 */
export const zCreateSectionCategoryRequest = z.object({
    name: z.string().max(150).optional()
});

/**
 * Payload to update a section
 */
export const zUpdateSectionCategoryRequest = z.object({
    name: z.string().max(150).optional()
});

export const zSiteSectionCategoryCreatedEntityReference = z.object({
    id: zSiteSectionCategoryId,
    type: z.literal('SiteSectionCategory')
});

export const zSectionCategoryViews = z.array(z.object({
    id: zSiteSectionCategoryId,
    name: z.string(),
    isDeletable: z.boolean(),
    linkedSectionCount: z.number().int()
}));

/**
 * Program ID
 */
export const zProgramId = z.number().int().min(-2147483648, { message: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' });

export const zDateTime = z.string();

/**
 * A program applied over a time window, shared by all target sections
 */
export const zCreateSectionProgrammingRangeRequest = z.object({
    programId: zProgramId,
    start: zDateTime,
    end: zDateTime.nullish()
});

/**
 * Payload to create or update the programming of several site sections with a shared range
 */
export const zCreateSectionProgrammingRangesRequest = z.object({
    sectionIds: z.array(zSiteSectionId).min(1),
    programmingRange: zCreateSectionProgrammingRangeRequest
});

/**
 * Unique identifier of a section programming range. Must be non-blank.
 */
export const zProgrammingRangeUuid = z.string().uuid();

/**
 * Fields to patch on one existing programming range of a site section. Omitted properties are left unchanged, and at least one of `programId`, `start` or `end` must be provided.
 */
export const zUpdateSectionProgrammingRangeRequest = z.object({
    programmingRangeUuid: zProgrammingRangeUuid,
    programId: zProgramId.optional(),
    start: zDateTime.optional(),
    end: zDateTime.nullish()
});

/**
 * Identifier of the programming range to delete from a site section
 */
export const zDeleteSectionProgrammingRangeRequest = z.object({
    programmingRangeUuid: zProgrammingRangeUuid
});

/**
 * Color chosen by a user to distinguish a program.
 */
export const zFrontDisplayColor = z.enum([
    'BLUE',
    'GREEN',
    'ORANGE',
    'RED',
    'PURPLE'
]);

/**
 * The program applied by the programming range.
 */
export const zProgrammingRangeProgramView = z.object({
    id: zProgramId,
    name: z.string(),
    frontColorDisplay: zFrontDisplayColor.nullish()
});

/**
 * A program applied to a section over a time window.
 */
export const zProgrammingRangeView = z.object({
    uuid: zProgrammingRangeUuid,
    program: zProgrammingRangeProgramView,
    start: zDateTime,
    end: zDateTime.nullish()
});

/**
 * A site section node with its programmings, forming a recursive tree through its children.
 */
export const zSectionWithProgrammingsNodeView: z.AnyZodObject = z.object({
    sectionId: zSiteSectionId,
    name: z.string(),
    parentId: zSiteSectionId.nullish(),
    category: zSectionCategory.nullish(),
    applianceCountByProgrammingCategory: zApplianceCountByProgrammingCategory,
    programmingRanges: z.array(zProgrammingRangeView),
    children: z.array(z.lazy(() => zSectionWithProgrammingsNodeView))
});

/**
 * Fields to patch on a site program. Omitted fields are left unchanged.
 */
export const zUpdateProgramRequest = z.object({
    name: z.string().max(150).optional(),
    frontDisplayColor: zFrontDisplayColor.nullish()
});

/**
 * Reference to a freshly created program.
 */
export const zProgramCreatedEntityReference = z.object({
    id: zProgramId,
    type: z.literal('Program')
});

/**
 * Type of program. Only SITE programs are returned by the site programs endpoint.
 */
export const zProgramType = z.enum(['DEFAULT', 'SITE']);

/**
 * A site program without its subprograms.
 */
export const zSimpleProgramView = z.object({
    id: zProgramId,
    name: z.string(),
    siteId: zSiteId,
    programType: zProgramType,
    frontColorDisplay: zFrontDisplayColor.nullish(),
    isSiteDefault: z.boolean(),
    isActive: z.boolean().optional()
});

/**
 * Time of day, without date, time zone or seconds.
 */
export const zTimeOfDay = z.string().regex(/^([01][0-9]|2[0-3]):[0-5][0-9]$/);

/**
 * Programming mode. Only a subset of these modes is valid for a given appliance category.
 */
export const zMetaMode = z.enum([
    'CONFORT',
    'ECO',
    'HORS_GEL',
    'ON',
    'OFF',
    'TEMPERATURE',
    'OCCUPIED',
    'AVAILABLE'
]);

/**
 * A mode applied over a time window within a day.
 */
export const zDailyProgramRangeView = z.object({
    startTime: zTimeOfDay,
    endTime: zTimeOfDay,
    metaMode: zMetaMode,
    temperature: z.number().nullish()
});

/**
 * Programming ranges of a subprogram by day of week, keyed by ISO-8601 day number (1 = Monday, 7 = Sunday). All seven days are always present.
 */
export const zDailyProgramRangesByDay = z.record(z.array(zDailyProgramRangeView).min(1));

/**
 * Weekly programming ranges of a subprogram.
 */
export const zSubprogramRequest = z.object({
    ranges: zDailyProgramRangesByDay
});

/**
 * Weekly programming ranges by appliance category. May be empty.
 */
export const zSubprogramRequestsByApplianceCategory = z.record(zSubprogramRequest);

/**
 * Payload to create a site program.
 */
export const zCreateProgramRequest = z.object({
    name: z.string().max(150),
    siteId: zSiteId,
    subprograms: zSubprogramRequestsByApplianceCategory,
    frontDisplayColor: zFrontDisplayColor.nullish()
});

/**
 * Weekly programming ranges by appliance category, for the requested categories.
 */
export const zSubprogramsByApplianceCategory = z.record(zDailyProgramRangesByDay);

/**
 * A site program with the weekly programming ranges of its subprograms.
 */
export const zDetailedProgramView = z.object({
    id: zProgramId,
    name: z.string(),
    siteId: zSiteId,
    isSiteDefault: z.boolean(),
    frontColorDisplay: zFrontDisplayColor.nullish(),
    subprograms: zSubprogramsByApplianceCategory
});

export const zLocalDate = z.string().date();

/**
 * A range between two dates, both included.
 */
export const zDateRangeRequest = z.object({
    from: zLocalDate,
    to: zLocalDate
});

/**
 * Period of the requested consumption, optionally narrowed to part of the site sections. When `requestedSectionCategoryIds` is present it drives the perimeter and `requestedSectionIds` only narrows it further; when only `requestedSectionIds` is present the perimeter is made of those sections; when neither is present the whole site is returned. As soon as the perimeter is narrowed, only the device consumption is computed: `global` and `globalCost` are then zero and `mainConsumptionSource` is `DEVICES`.
 */
export const zDateRangeConsumptionRequest = z.object({
    dateRange: zDateRangeRequest,
    requestedSectionIds: z.array(zSiteSectionId).min(1).nullish(),
    requestedSectionCategoryIds: z.array(zSiteSectionCategoryId).min(1).nullish()
});

/**
 * Unit a consumption metric is expressed in.
 */
export const zMetricUnit = z.enum([
    'Wh',
    '%',
    '€',
    'N/A'
]);

/**
 * A single numeric metric with its unit.
 */
export const zNumberMetric = z.object({
    value: z.number().nullable(),
    unit: zMetricUnit
});

/**
 * Device consumption of one site section over the requested period.
 */
export const zSectionConsumptionsResponse = z.object({
    sectionId: zSiteSectionId,
    sectionName: zSiteSectionName,
    total: zNumberMetric,
    lastPeriodTotal: zNumberMetric,
    evolution: zNumberMetric,
    consumptionPerArea: zNumberMetric,
    isParent: z.boolean()
});

/**
 * Consumption measured on a single day.
 */
export const zTimePoint = z.object({
    value: z.number().nullable(),
    date: zLocalDate,
    isComplete: z.boolean()
});

/**
 * A daily time series with the unit shared by all its points.
 */
export const zTimePointsMetric = z.object({
    value: z.array(zTimePoint),
    unit: zMetricUnit
});

/**
 * Appliance category used by the consumption dashboard. Coarser than the programming appliance category: every appliance type the dashboard does not know falls into OTHER.
 */
export const zConsumptionDashboardApplianceCategory = z.enum([
    'HEATER',
    'WATER_HEATER',
    'AIR_CONDITIONING_COOLING',
    'HEAT_PUMP',
    'OTHER'
]);

/**
 * Consumption of every appliance of one dashboard category.
 */
export const zApplianceCategoryConsumption = z.object({
    category: zConsumptionDashboardApplianceCategory,
    consumption: z.number()
});

/**
 * A consumption broken down by appliance category, with the unit shared by all its entries.
 */
export const zApplianceCategoryConsumptionsMetric = z.object({
    value: z.array(zApplianceCategoryConsumption),
    unit: zMetricUnit
});

/**
 * Source the headline consumption figures are taken from. DSO when the metering readings of the site are used, DEVICES when only the Voltalis device measures are available.
 */
export const zMainConsumptionSource = z.enum(['DSO', 'DEVICES']);

/**
 * Consumption of one site over the requested period.
 */
export const zMonoSiteConsumptionResponse = z.object({
    global: zNumberMetric,
    globalByDay: zTimePointsMetric,
    globalCost: zNumberMetric,
    totalDevices: zNumberMetric,
    devicesByDay: zTimePointsMetric,
    devicesByCategory: zApplianceCategoryConsumptionsMetric,
    devicesCount: z.number().int().gte(0).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' }),
    devicesBySection: z.array(zSectionConsumptionsResponse),
    totalEvolution: zNumberMetric,
    totalPerArea: zNumberMetric,
    mainConsumptionSource: zMainConsumptionSource
});

/**
 * Appliance ID
 */
export const zApplianceId = z.number().int().min(-2147483648, { message: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' });

/**
 * A programmable appliance attached to a site section.
 */
export const zProgrammableApplianceView = z.object({
    applianceId: zApplianceId,
    category: zApplianceCategory,
    name: z.string()
});

/**
 * Move several appliances to a target site section in one operation.
 */
export const zBulkMoveAppliancesRequest = z.object({
    applianceIds: z.array(zApplianceId).min(1),
    targetSectionId: zSiteSectionId
});

/**
 * Site ID
 */
export const zSiteIdPathParam = zSiteId;

/**
 * Site section ID
 */
export const zSiteSectionIdPathParam = zSiteSectionId;

/**
 * Site section category ID
 */
export const zSiteSectionCategoryIdPathParam = zSiteSectionCategoryId;

/**
 * Program ID
 */
export const zProgramIdPathParam = zProgramId;

/**
 * Section forest found
 */
export const zFindSectionForestResponse = zHospitalitySectionForestResponse;

/**
 * Site section created
 */
export const zCreateSiteSectionResponse = zSiteSectionCreatedEntityReference;

/**
 * Section patched
 */
export const zPatchSiteSectionResponse = z.void();

/**
 * Section deletability status
 */
export const zIsSectionDeletableResponse = zSectionDeletableResponse;

/**
 * Section moved
 */
export const zMoveSectionResponse = z.void();

/**
 * Sections updated with categories
 */
export const zUpdateSectionsCategoriesResponse = z.void();

/**
 * Site section categories found
 */
export const zGetSiteSectionCategoriesResponse = zSectionCategoryViews;

/**
 * Site section category created
 */
export const zCreateSectionCategoryResponse = zSiteSectionCategoryCreatedEntityReference;

/**
 * Section programmings upserted
 */
export const zCreateSectionProgrammingRangesResponse = z.void();

/**
 * Root site sections. Empty when the site has no sections.
 */
export const zGetSectionProgrammingsPlanningResponse = z.array(zSectionWithProgrammingsNodeView);

/**
 * Programming range updated
 */
export const zUpdateProgrammingRangeResponse = z.void();

/**
 * Programming range deleted
 */
export const zDeleteProgrammingRangeResponse = z.void();

/**
 * Program created
 */
export const zCreateProgramResponse = zProgramCreatedEntityReference;

/**
 * Program found
 */
export const zGetSiteProgramResponse = zDetailedProgramView;

/**
 * Site programs.
 */
export const zGetSiteProgramsResponse = z.array(zSimpleProgramView).min(0);

/**
 * Site consumption computed
 */
export const zGetSiteConsumptionsResponse = zMonoSiteConsumptionResponse;

/**
 * Programmable appliances found
 */
export const zFindAllV2Response = z.array(zProgrammableApplianceView);
